import Shader from "_src/engine/shader";

import vertText from "_src/shaders/grain/grain.glslv";
import fragText from "_src/shaders/grain/grain.glslf";
import Uniform from "_src/engine/uniform";
import {uniformType} from "_src/engine/constants";

export default class GrainShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);
    this.depthTest = false;
  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms(params) {
    const strength = "strength" in params ? params.strength : 0.5;
    this.uniforms["u_strength"] = new Uniform(uniformType.FLOAT1, strength);
  }

  setStrength(strength) {
    this.setUniform("u_strength", strength);
  }

}
